import React from "react";
import { motion } from "framer-motion";
import { CheckIcon, GlobeIcon } from "lucide-react";
import { Reveal, Eyebrow, SectionTitle, goToCheckout, TrustBadges } from "./ui";
import { heroMockup, offerIncludes, PRICE_CURRENT } from "./data";
export function Offer() {
  return <section id="oferta" className="w-full scroll-mt-4 bg-white px-4 py-12 sm:px-8 sm:py-20" data-id="element-116" data-mp="1hopgpoft3ufv">
      <div className="mx-auto max-w-xl" data-id="element-117" data-mp="tybkrmu3pbg0">
        <Reveal className="text-center" data-id="element-118" data-mp="tzd7wpoe5oe3">
          <Eyebrow data-id="element-119" data-mp="ozs1xvat0frv">La oferta</Eyebrow>
          <SectionTitle data-id="element-120" data-mp="p0tjmimbs0ik">Todo incluido. Un único precio.</SectionTitle>
          <p className="mt-3 text-sm text-[var(--muted)] sm:text-base" data-id="element-121" data-mp="13wrbhop7uioz">
            Sin suscripciones. Sin pagos mensuales.
          </p>
        </Reveal>

        <Reveal delay={0.08} data-id="element-122" data-mp="ywmwy47vby1e">
          <div className="mt-7 overflow-hidden rounded-[1.75rem] border border-[#e2ecf7] bg-white shadow-[0_32px_70px_-34px_rgba(23,50,77,0.6)] sm:mt-10 sm:rounded-[2.25rem]" data-id="element-123" data-mp="2fc68utlc7ckm">
            <div className="relative overflow-hidden bg-[var(--ink)] px-5 pb-6 pt-6 text-center sm:px-10 sm:pb-8 sm:pt-8" data-id="element-124" data-mp="2af7gafhbndoj">
              <div className="pointer-events-none absolute -left-12 top-2 h-32 w-32 rounded-full bg-[#2d74e8]/35 blur-3xl" data-id="element-125" data-mp="uj1weh02zxqe" />
              <p className="relative text-[11px] font-extrabold uppercase tracking-[0.16em] text-white/80" data-id="element-126" data-mp="zi53s83jag1j">
                Pequeños Pasos, Grandes Logros™
              </p>
              <img src={heroMockup} alt="Colección digital completa Pequeños Pasos, Grandes Logros" className="relative mx-auto mt-4 h-40 w-auto rounded-2xl border-2 border-white/85 object-contain shadow-[0_24px_40px_-20px_rgba(0,0,0,0.85)] sm:h-56" loading="lazy" data-id="element-127" data-mp="6tzh3fsx6gz2" />
              <p className="relative mt-3 text-sm font-semibold text-white/75" data-id="element-128" data-mp="klxjl7s4lem9">
                Colección digital completa
              </p>
            </div>

            <div className="px-5 pb-6 pt-6 sm:px-9 sm:pb-9 sm:pt-8" data-id="element-129" data-mp="3o9z95aze2icn">
              <p className="text-center text-[11px] font-extrabold uppercase tracking-[0.16em] text-[var(--accent)]" data-id="element-130" data-mp="3o84olxs14s93">
                ¿Qué recibís?
              </p>
              <ul className="mt-4 grid gap-2 text-left sm:grid-cols-2 sm:gap-2.5" data-id="element-131" data-mp="qfutg3y8dnd6">
                {offerIncludes.map(item => <li key={item} className="flex min-h-[46px] items-center gap-2.5 rounded-xl border border-[#e2edf8] bg-[#f8fbff] px-3 py-2" data-id="element-132" data-mp="157mynn4b9l16">
                    <span className="flex h-5 w-5 flex-none items-center justify-center rounded-full bg-[var(--accent-green)] text-white" data-id="element-133" data-mp="cippqalzp0l3">
                      <CheckIcon className="h-3 w-3" aria-hidden data-id="element-134" data-mp="lht8fdh8vdz2" />
                    </span>
                    <span className="text-xs font-bold leading-tight text-[var(--ink)] sm:text-[13px]" data-id="element-135" data-mp="hfg1wmuobc18">
                      {item}
                    </span>
                  </li>)}
              </ul>

              <div className="my-6 border-t border-dashed border-[#d7e3ef] sm:my-7" data-id="element-136" data-mp="1su376qweoqbc" />

              <div className="text-center" data-id="element-137" data-mp="20edztbw30ht7">
                <p className="text-[11px] font-extrabold uppercase tracking-[0.16em] text-[var(--muted)]" data-id="element-138" data-mp="20gqgllq3sm4o">
                  Acceso completo hoy por
                </p>
                <p className="mt-1 font-serif-display text-[3.6rem] font-semibold leading-none tracking-[-0.04em] text-[var(--ink)] sm:text-[4.5rem]" data-id="element-139" data-mp="1qhrhouv544uv">
                  {PRICE_CURRENT}
                </p>
                <p className="mt-2 text-[11px] font-bold uppercase tracking-[0.08em] text-[var(--accent-green)]" data-id="element-140" data-mp="2j6gdqfhc9jzr">
                  Pago único · Sin suscripciones · Acceso inmediato
                </p>
              </div>

              <div className="mt-5 flex items-start gap-2.5 rounded-2xl bg-[#f4f8fd] p-3.5 text-left sm:p-4" data-id="element-141" data-mp="29d98qvqig607">
                <GlobeIcon className="mt-0.5 h-4 w-4 flex-none text-[var(--accent)]" aria-hidden data-id="element-142" data-mp="2ec2ajqwfq8kj" />
                <div data-id="element-143" data-mp="3226ejzdjcac2">
                  <p className="text-[11px] font-extrabold uppercase tracking-[0.1em] text-[var(--ink)]" data-id="element-144" data-mp="36ug2j9v3b0bp">
                    Compra internacional
                  </p>
                  <p className="mt-1 text-[11px] leading-relaxed text-[var(--muted)] sm:text-xs" data-id="element-145" data-mp="1j4bgtgs1zzj0">
                    El precio está expresado en dólares estadounidenses. El importe final y la
                    conversión de moneda dependen del método de pago y de tu entidad emisora.
                  </p>
                </div>
              </div>

              <motion.button type="button" onClick={goToCheckout} whileHover={{
              scale: 1.015
            }} whileTap={{
              scale: 0.985
            }} transition={{
              type: "spring",
              stiffness: 420,
              damping: 24
            }} className="mt-5 w-full rounded-2xl bg-[var(--accent)] px-5 py-4 text-[15px] font-extrabold uppercase leading-snug text-white shadow-[0_18px_38px_-14px_rgba(41,111,232,0.65)] transition-colors duration-200 ease-out hover:bg-[#245dc3] focus:outline-none focus-visible:ring-4 focus-visible:ring-[var(--accent)]/30 sm:py-5 sm:text-lg" data-id="element-146" data-mp="21x5orqr9erdq">
                Quiero acceder ahora →
              </motion.button>

              <TrustBadges className="mt-4" data-id="element-147" data-mp="2s64re2nvr3sl" />
            </div>
          </div>
        </Reveal>
      </div>
    </section>;
}